import {NgModule}       from '@angular/core';
import {CommonModule}   from '@angular/common';
import {FormsModule}    from '@angular/forms';

import {FileUploadModule} from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';

import {themesRouting} from './themes.routing'

import {ThemeListComponent} from './theme-list.component';
import {ThemeFormComponent} from './theme-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FileUploadModule,
        InputTextareaModule,
        InputTextModule,
        DropdownModule,
        themesRouting
    ],
    declarations: [
        ThemeListComponent,
        ThemeFormComponent
    ]
})
export class ThemesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/themes/themes.module.ts